import type { SVGProps } from 'react';

/**
 * YouTube Shorts glyph — replicated verbatim from Figma's
 * "youtube-shorts 1" icon component (file 0Vugg58oB0iBf1CxP0CUyp, Approve
 * Creator deliverable list). The actual Shorts swirl/play mark — a
 * previous version of this icon used an unrelated bolt shape. Stroke-based
 * (not filled), using `currentColor` so it composes with the app's
 * deliverable-card icon treatment.
 */
export function YoutubeShortsIcon({
  size = 20,
  className,
  weight: _weight,
  ...props
}: SVGProps<SVGSVGElement> & { size?: number; weight?: string }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      className={className}
      {...props}
    >
      <path
        d="M6.251 6.996L14.392 2.6675C14.8306 2.43449 15.3137 2.29585 15.8091 2.2605C16.3046 2.22514 16.8019 2.29384 17.2692 2.4622C17.7365 2.63055 18.1634 2.89483 18.5224 3.23803C18.8815 3.58124 19.1647 3.99578 19.354 4.455C20.067 6.1715 19.2395 8.1505 17.599 9.023L16.044 9.85C15.854 9.951 15.9285 10.2355 16.144 10.231C16.8611 10.2172 17.5658 10.4203 18.1655 10.8137C18.7652 11.2072 19.2321 11.7727 19.505 12.436C20.218 14.1525 19.3905 16.1315 17.7495 17.004L9.608 21.3325C9.16933 21.5656 8.68673 21.7043 8.19124 21.7397C7.69575 21.7751 7.19834 21.7064 6.73099 21.5381C6.26363 21.3697 5.83669 21.1054 5.4776 20.7621C5.11852 20.4189 4.83525 20.0043 4.646 19.545C3.933 17.829 4.7605 15.85 6.4015 14.9765L7.9565 14.15C8.1465 14.049 8.0715 13.7645 7.8565 13.769C7.13927 13.7829 6.43455 13.5799 5.83472 13.1864C5.23488 12.7929 4.76791 12.2274 4.495 11.564C3.782 9.8475 4.6095 7.8685 6.251 6.996Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.702 12.1265L10.1555 9.5015V14.7515L14.702 12.1265Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
